import React, {memo} from 'react';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {AppModal, Col, UiButton, UiImage, UiText} from '../elements';

interface Props {
  isShowing: boolean;
  onDismissModal?: () => void;
  onClickSubmit?: () => void;
  title?: string;
  buttonTitle?: string;
  children?: React.ReactNode;
  hideCloseButton?: boolean;
  logo?: string;
}

const TextModal = ({
  isShowing,
  onDismissModal,
  onClickSubmit,
  title,
  buttonTitle,
  children,
  hideCloseButton,
  logo,
}: Props) => {
  const dispatch: AppDispatch = useDispatch();

  const onCloseModal = () => {
    if (onDismissModal) {
      onDismissModal();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    if (onClickSubmit) {
      onClickSubmit();
    }
    onCloseModal();
  };

  return !isShowing ? null : (
    <AppModal
      actions={null}
      isOpen={isShowing}
      onClose={onCloseModal}
      contentMinW="40%"
      isCentered
      size="2xl"
      hideCloseButton={hideCloseButton}
    >
      <Col alignItems="center" textAlign="center" pb="20px">
        {logo && <UiImage type="icon" name={logo} boxSize="150px" objectFit="contain" />}
        <UiText fontSize="xl" fontWeight="600">
          {title}
        </UiText>
        {children}
        {onClickSubmit && <UiButton mt="35px" width="90%" title={buttonTitle} onClick={handleSubmit} />}
      </Col>
    </AppModal>
  );
};

export default memo(TextModal);
